var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M22 11.94c0-5.557-4.477-10.062-10-10.062S2 6.383 2 11.94c0 5.021 3.657 9.184 8.438 9.938v-7.03h-2.54v-2.909h2.54V9.724c0-2.522 1.492-3.914 3.777-3.914 1.094 0 2.238.196 2.238.196v2.476h-1.26c-1.243 0-1.63.776-1.63 1.571v1.888h2.773l-.443 2.908h-2.33v7.03C18.343 21.124 22 16.961 22 11.94Z",
    fill: "currentColor"
  })));
};
export default SvgFacebook;